import dayjs from "dayjs";
import { useEffect } from "react";
import MovingText from "react-moving-text";
import parse from "html-react-parser"
import { formatDateWithOrdinal } from "../../utils/helpers";
import Banner from  '../../assets/privacy-banner.png'

const CheckIcon = () => {
  return <div className="flex items-center flex-shrink-0 text-[20px] text-green-700">✔</div>
}

const CheckedLine = ({ children }) => {
  return <span className="flex my-1  items-start lg:items-center gap-1 font-normal tracking-wide text-slate-800">
    <CheckIcon />
    &nbsp;
    <div>
      {children}
    </div>
  </span>
}

const PrivacyPolicy = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const buildDate = process.env.REACT_APP_BUILD_DATE;
  const currDate = formatDateWithOrdinal(dayjs())
  const date = buildDate ? buildDate : currDate

  return <div className="py-12 sm:py-8 font-notosans sm:px-10 px-3">
    <div className="flex flex-col sm:flex-row justify-between items-center">
      <p className="banner-text-shadow text-4xl text-center sm:text-left sm:text-6xl text-[#1c7e4bea] tracking-wider font-bold z-[2]">
        Privacy Policy
      </p>
      <img
        src={Banner}
        alt="banner"
        className="h-[auto] w-[94vw] scale-110 sm:scale-100 sm:w-[auto] sm:h-[250px] md:h-[300px] lg:h-[380px] xl:h-[420px] z-[1]"
      />
      <div className="w-full h-[400px] sm:h-[350px] md:h-[400px] lg:h-[500px] object-cover absolute top-0 left-0 z-[-1] bg-gradient-to-b sm:bg-gradient-to-r to-[#3bae73ea] via-[#4ad68e80] from-[#fff0]">

      </div>
    </div>
    <p className="text-xs tracking-wider mt-4">
      Last updated: <span className="italic">{parse(date)}</span>
    </p>
    <p className="text-lg mt-[2rem]">
      We at Flint are committed to protecting your privacy and developing technology that gives you the most powerful and secure online experience. You can go through our site without giving us any information about yourself. However, sometimes we may need your information to provide the services you request, and this statement of privacy explains Flint's data collection and use practices in those situations.
    </p>

    <div className="mt-8">
      <p className="text-2xl sm:text-2xl font-bold text-[#333e49]">
        <MovingText
          type="fadeInFromLeft"
          duration="1000ms"
          delay="0s"
          direction="normal"
          timing="ease"
          iteration="1"
          fillMode="none"
        >
          Collecting Your Personal Information
        </MovingText>
      </p>
      <p className="text-lg mt-3">
        We will ask you when we need information that personally identifies you (personal information) or allows us to contact you. This information is limited to your name, e-mail address, telephone number, company affiliation, country, or location. However, it may include other necessary information to provide your requested service.
      </p>

      <div className="mt-4">
        <p className="text-[1.15rem] font-notosans font-semibold flex items-center gap-2">
          <div className="w-2 h-2 rounded-[50vw] bg-green-700 "></div>
          <div className="mb-1">We collect information via the following modes or platforms:</div>
        </p>
        <p>
          <CheckedLine>
            When you visit the Websites owned by Flint Infotech LLP.
          </CheckedLine>
        </p>
        <p>
          <CheckedLine>
            When you interact with us on social platforms like LinkedIn, Facebook, Twitter, and Google.
          </CheckedLine>
        </p>
        <p>
          <CheckedLine>
            When you interact on communication platforms like WhatsApp for Business, Microsoft Teams, Zoom, Google Meet/Duo, and others.
          </CheckedLine>
        </p>
      </div>
    </div>

    <div className=" mt-8">
      <p className="text-[1.15rem] font-notosans font-semibold flex items-center gap-2">
        <div className="w-2 h-2 rounded-[50vw] bg-green-700 "></div>
        <div className="mb-1">We use your personal information for the following purposes:</div>
      </p>
      <p>
        <CheckedLine>
          Make your website visit, marketing experience, and communications tailored to your interests based on your personal information.
        </CheckedLine>
      </p>
      <p>
        <CheckedLine>
          Deliver support and services that you request or purchase.
        </CheckedLine>
      </p>
      <p>
        <CheckedLine>
          Evaluate and improve our products, services, marketing, and customer relationships.
        </CheckedLine>
      </p>
      <p>
        <CheckedLine>
          Interact with you on the third-party social networks. Our interactions with you on a third-party social network would be subject to the respective network’s privacy policies and terms of use.
        </CheckedLine>
      </p>
      <p>
        <CheckedLine>
          Alert you of product upgrades, exclusive offers, updated information, and other new services from Flint.
        </CheckedLine>
      </p>
      <p>
        <CheckedLine>
          Communicate with you about conferences, workshops or any other events hosted or co-hosted by Flint or one of our partners.
        </CheckedLine>
      </p>
    </div>

    <div className="mt-8">
      <p className="text-2xl sm:text-2xl font-bold text-[#333e49]">
        <MovingText
          type="fadeInFromLeft"
          duration="1000ms"
          delay="0s"
          direction="normal"
          timing="ease"
          iteration="1"
          fillMode="none"
        >
          Security Of Your Personal Information
        </MovingText>
      </p>
      <p className="text-lg mt-3">
        We strictly protect the security of your personal information and honor your choices for its intended use.
      </p>
    </div>

    <div className="mt-8">
      <p className="text-2xl sm:text-2xl font-bold text-[#333e49]">
        <MovingText
          type="fadeInFromLeft"
          duration="1000ms"
          delay="0s"
          direction="normal"
          timing="ease"
          iteration="1"
          fillMode="none"
        >
          Changes To This Statement
        </MovingText>
      </p>
      <p className="text-lg mt-3">
        We will occasionally update this privacy statement. When we do, we will also revise the “last updated" date at the top of the privacy statement. Kindly check this page regularly to review if any changes are introduced.
      </p>
    </div>

    <div className="mt-8">
      <p className="text-2xl sm:text-2xl font-bold text-[#333e49]">
        <MovingText
          type="fadeInFromLeft"
          duration="1000ms"
          delay="0s"
          direction="normal"
          timing="ease"
          iteration="1"
          fillMode="none"
        >
          Contact Information
        </MovingText>
      </p>
      <p className="text-lg mt-3">
        If you have any questions about this Statement of Privacy, please write to us at <a href="mailTo:info@flintinfotech.com" className="text-green-700 hover:underline">info@flintinfotech.com</a>
      </p>
    </div>
  </div>
}

export default PrivacyPolicy;